import { Stack } from '@mui/material'
import RepairShopSelection from '@src/components/RepairShopSelection'
import SvvSpinner from '@src/components/SvvSpinner'
import UserAccidentInfo from '@src/components/UserAccidentInfo'
import useRepairShopMatch from '@src/hooks/useRepairShopMatch'
import React, { Fragment, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

const SelectionPage = () => {
  const { uuid } = useParams()
  const { searchResult, loading } = useRepairShopMatch(uuid)
  const navigate = useNavigate()

  useEffect(() => {
    if (
      searchResult &&
      searchResult.results.find((repairShop) => repairShop.selected)
    ) {
      navigate(`/${uuid}/valmis`)
    }
  }, [searchResult, navigate, uuid])

  if (loading) {
    return <SvvSpinner />
  }

  return (
    <Fragment>
      {searchResult && (
        <Stack>
          <UserAccidentInfo
            lossDate={searchResult.claim.lossDate}
            registrationNumber={searchResult.vehicle.registrationNumber}
          />
          <RepairShopSelection
            uuid={uuid ? uuid : ''}
            repairShops={searchResult.results}
          />
        </Stack>
      )}
    </Fragment>
  )
}

export default SelectionPage
